<div style="display: flex; flex-direction: column">
    <div style="flex-basis: 50%">
        <app-shopee-orders title="Shopee (gen4)"></app-shopee-orders>
    </div>
</div>
